import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Container, Col, Row, Alert } from 'reactstrap';
import { DownloadOutlined, InboxOutlined } from '@ant-design/icons';
import { Button, Upload, Divider } from 'antd';
import { Document, Page } from 'react-pdf';

// Local Deps
import './UploadInventory.scss';
import UploadInventoryHOC from './UploadInventoryHOC';
// DO NOT DELETE import uploadInventoryHelp from '../../HelpFiles/Inventory Management Upload Example and Instructions.pdf';
import msgs from '../../config/messages';
import { cloudFrontCdnUrl, s3SupportDocs } from '../../config/properties';

// import uploadInventoryTemplate from '../../HelpFiles/InventoryManagementDataTemplate.csv';
// import uploadInventoryHelp from '../../HelpFiles/Inventory Management Upload Example and Instructions.pdf'

const uploadInventoryHelp = `${s3SupportDocs}/ToolingAndInventory/Inventory Management Upload Example and Instructions.pdf`
const uploadInventoryTemplate = `${s3SupportDocs}/ToolingAndInventory/InventoryManagementDataTemplate.csv`

const { Dragger } = Upload;

// const HelpOver = (
//   <span>
//     <p>You will need to format your files. Click here for more information</p>
//   </span>
// );
class UploadInventory extends Component {


  static propTypes = {
    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
    hideMessage: PropTypes.func.isRequired,
    handleUpload: PropTypes.func.isRequired,
    onReturnToMainPage: PropTypes.func.isRequired,
  };

  static initialState = {};

  state = UploadInventory.initialState;

  render() {
    const {
      alertType,
      alertMessage,
      hideMessage,
      handleUpload,
    } = this.props;

    return (
      <div className="nf-add-tool">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Upload Inventory Page</title>
        </Helmet>
        <Container>
          <Col sm={12}>
            <br />
            {/* <Row
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
              }}
            >
              <h3 style={{ fontWeight: 400, marginLeft: '40px' }}>
                Upload Inventory
              </h3>
              <Col xs="auto" className="upload-products-header">
                <Popover placement="rightTop" content={HelpOver}>
                  <a href={uploadInventoryHelp} target="_blank">
                    <Button
                      style={{
                        backgroundColor: '#ff7c52',
                        color: 'white',
                        border: 'none',
                      }}
                      size="small"
                      shape="circle"
                    >
                      ?
                    </Button>
                  </a>
                </Popover>
              </Col>
            </Row> */}
            <br />
            <Dragger
              accept=".csv"
              customRequest={handleUpload}
              showUploadList={false}
            >
              <p style={{ fontSize: '48px', color: '#ff7c52' }}>
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
              <p className="ant-upload-hint">
                <ul>
                  <ul>
                    {' '}
                    Once you select a file, the upload process will begin
                    immediately. Please make sure that the file you selected is
                    the correct one
                  </ul>
                  <ul>
                    In order for your file to be processed correctly, you may
                    need to format it.
                  </ul>
                  <ul><u>Only .csv files will be processed</u></ul>
                </ul>
              </p>

            </Dragger>

            <Col xs="auto">
              {/* <Row
                style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                }}
              >
                <Alert color="light" style={{ fontSize: '.75rem' }} />
              </Row> */}
              <Row
                style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                }}
              >
                {alertMessage && (
                  <Alert color={alertType} toggle={hideMessage}>
                    {alertMessage}
                  </Alert>
                )}
              </Row>
              <Row
                style={{
                  // 'margin-left': '15vw',
                  display: 'block',
                  textAlign: 'left',
                  marginTop: '20px',
                }}
              >
                <p>1. The uploaded file must be in the same format as the downloaded file. Download the template here:
                  <a href={uploadInventoryTemplate} target="_blank" rel="noreferrer">
                    <Button icon={<DownloadOutlined />} primary className='ndaBtns'>
                      Inventory Template
                    </Button>
                  </a>
                </p>
                <p>2. Save the file as comma-separated values (*.csv). </p>
                <p>3. Please follow the direction of the PDF Help File provided below.  Click here to download the file:
                  <a href={uploadInventoryHelp} target="_blank" rel="noreferrer">
                    <Button icon={<DownloadOutlined />} primary className='ndaBtns'>
                      PDF Help File
                    </Button>
                  </a>
                </p>
                <p>4. Records will not show if the .csv file is not configured to the template and directions given on the PDF help file.</p>
                <p>5. Your Inventory records will be completely overlaid with this file, but Tooling management records with the same Part Number and NSN will not be affected. </p>

              </Row>


            </Col>
          </Col>
          <Row
            style={{
              display: 'flex',
              justifyContent: 'space-around',
            }}
          >
            {/* <embed src={`${uploadInventoryHelp}#toolbar=0&navpanes=0&scrollbar=0&zoom=100`} type="application/pdf" width="834px" height="1107px" /> */}
            {/* <iframe src={`${uploadInventoryHelp}#toolbar=0&navpanes=0&scrollbar=0&zoom=100`} height="1107" width="834" title="Upload Inventory Help" /> */}
            <a href={uploadInventoryHelp} target="_blank" rel="noreferrer">
              <Document
                file={`${cloudFrontCdnUrl}/${uploadInventoryHelp}`}
              >
                <Page pageNumber={1} />
              </Document>
            </a>
          </Row>

          <Divider />

          <Row
            style={{
              display: 'flex',
              justifyContent: 'space-around',
            }}
          >
            <Button
              key="back"
              className="nf-button nf-button--gray-border"
              style={{ marginBottom: '20px' }}
              onClick={this.props.onReturnToMainPage}
            >
              {msgs.Form.cancelButton}
            </Button>
          </Row>

        </Container>
      </div>
    );
  }
}

export default UploadInventoryHOC(UploadInventory);



// WEBPACK FOOTER //
// ./src/components/UploadInventory/UploadInventory.jsx